import { TransformationResponseDto } from './ApiType';

export const mockGetTransformations: TransformationResponseDto[] = [
  {
    id: 1,
    name: '1',
    xmlUrl: 'https://url.com/1.xml',
    xsltDefinition: 'definition 1',
    authenticated: false,
  },
  {
    id: 2,
    name: '2',
    xmlUrl: 'https://url.com/2.xml',
    xsltDefinition: 'definition 2',
    authenticated: true,
  },
  {
    id: 3,
    name: '3',
    xmlUrl: 'https://url.com/3.xml',
    xsltDefinition: 'definition 3',
    authenticated: false,
  },
];

export const mockGetTransformation: TransformationResponseDto = {
  id: 1,
  name: '1',
  xmlUrl: 'http://url.com/1.xml',
  xsltDefinition: 'definition 1',
  authenticated: true,
};

export const mockGetPreviewDom: string = ''
    + '<?xml version="1.0" encoding="UTF-8"?>\n'
    + '<SHOP>\n'
    + '    <SHOPITEM>\n'
    + '        <ITEM_ID>12345</ITEM_ID>\n'
    + '        <PRICE_VAT>100.00</PRICE_VAT>\n'
    + '        <EAN>EAN12345</EAN>\n'
    + '    </SHOPITEM>\n'
    + '</SHOP>\n'
    + '</xml>';

export const mockGetPreviewTransformation: string = ''
    + '<?xml version="1.0" encoding="UTF-8"?>\n'
    + '<MARKETPLACE>\n'
    + '    <PRODUCT>\n'
    + '        <ID>12345</ITEM_ID>\n'
    + '        <PRICE>100</PRICE_VAT>\n'
    + '        <EAN>EAN12345</EAN>\n'
    + '    </PRODUCT>\n'
    + '</MARKETPLACE>\n'
    + '</xml>';
